const escapeHTML = (s: string) =>
  s.replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!
  );

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function highlightToHTML(
  text: string,
  highlight: string,
  opts: { className?: string; caseSensitive?: boolean } = {}
): string {
  if (!highlight) return escapeHTML(text);
  const { className = 'highlight', caseSensitive = false } = opts;

  const re = new RegExp(`(${escapeRegExp(highlight)})`, caseSensitive ? 'g' : 'gi');
  const parts = text.split(re);

  return parts
    .map((part, i) =>
      i % 2 === 1 ? `<span class="${className}">${escapeHTML(part)}</span>` : escapeHTML(part)
    )
    .join('');
}
